// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"07c47727","453":"d6e69f26","705":"67def199"}[chunkId] + ".chunk.js";
};